// src/utils/loadGooglePlaces.js
let loadingPromise;

export async function loadGooglePlaces(apiKey) {
  // If Places is already present (e.g., another script loaded it), just return.
  if (window.google?.maps?.places) return;

  if (!apiKey) {
    throw new Error("Missing Google Maps API key");
  }

  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    const cb = "__onGoogleMapsLoaded__" + Math.random().toString(36).slice(2);
    window[cb] = () => {
      delete window[cb];
      if (window.google?.maps?.places) resolve();
      else reject(new Error("Google Maps Places library not available after load"));
    };

    const script = document.createElement("script");
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}` +
      `&libraries=places&v=weekly&loading=async&callback=${cb}`;
    script.async = true;           // still good to set
    script.defer = true;
    script.onerror = () => reject(new Error("Failed to load Google Maps JS"));
    document.head.appendChild(script);
  });

  return loadingPromise;
}
